import Image from "next/image";
import { ModalContent } from "@/components/core/ModalContent";
import { Enum_Componentcmsdataproductslist_Popuptype } from "@/generated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { ViewProps } from "../SliderType/components/PopupSlider/types";
import { WAccordion } from "@/components";

export const PopupModal = ({
  isModalOpen,
  handleCloseModal,
  products,
  selectedImageIndex,
  showInPopup,
  popupType,
  canScrollLeft,
  canScrollRight,
  thumbnailsContainerRef,
  firstThumbnailRef,
  slidePrevThumbnails,
  slideNextThumbnails,
  updateScrollButtons,
  setSelectedImageIndex,
  selectedItem,
}: ViewProps) => (
  <ModalContent isOpen={isModalOpen} onClose={handleCloseModal}>
    <div className="relative w-full flex flex-col items-center gap-10">
      {/* Main Image Section */}
      <div className="w-full lg:w-2/3 flex flex-col items-center">
        {(products?.data?.[selectedImageIndex]?.attributes?.media?.data?.[0]
          ?.attributes?.formats?.large?.url ||
          products?.data?.[selectedImageIndex]?.attributes?.media?.data?.[0]
            ?.attributes?.url ||
          selectedItem?.image) && (
          <div className="w-full h-96 overflow-hidden relative">
            <Image
              src={
                products?.data?.[selectedImageIndex]?.attributes?.media
                  ?.data?.[0]?.attributes?.formats?.large?.url ||
                products?.data?.[selectedImageIndex]?.attributes?.media
                  ?.data?.[0]?.attributes?.url ||
                selectedItem?.image
              }
              alt={
                products?.data?.[selectedImageIndex]?.attributes?.media
                  ?.data?.[0]?.attributes?.alternativeText || "image"
              }
              width={470}
              height={470}
              className="w-full h-full object-contain"
              quality={80}
            />
          </div>
        )}

        <span className="mt-4 text-3xl font-bold text-center">
          {products?.data?.[selectedImageIndex]?.attributes?.title ||
            selectedItem?.title}
        </span>
        <div className="text-left flex-1 w-full">
          {showInPopup?.includes("price") && (
            <p className="text-gray-500 !text-2xl mt-2">
              {products?.data?.[selectedImageIndex]?.attributes?.price ||
                selectedItem?.price}
              lei
            </p>
          )}
          {showInPopup?.includes("description") && (
            <p className="text-gray-500 mt-2">
              {products?.data?.[selectedImageIndex]?.attributes?.description ||
                selectedItem?.description}
            </p>
          )}
          {showInPopup?.includes("weight") && (
            <p className="text-gray-500 mt-2">
              {products?.data?.[selectedImageIndex]?.attributes?.weight ||
                selectedItem?.weight}
              g
            </p>
          )}
          <div className="mt-4">
            <WAccordion
              tabs={[
                showInPopup?.includes("nutritional_info") && {
                  title: "Informații nutritive",
                  content:
                    products?.data?.[selectedImageIndex]?.attributes
                      ?.nutritional_information ||
                    selectedItem?.nutritional_information,
                },
                showInPopup?.includes("ingredients") && {
                  title: "Ingrediente",
                  // Products or selectedItem
                  content:
                    products?.data?.[
                      selectedImageIndex
                    ]?.attributes?.ingredients?.data
                      ?.map((item) => item.attributes?.name)
                      .filter(Boolean)
                      ?.filter(
                        (allergen, index, self) =>
                          self.indexOf(allergen) === index
                      )
                      .join(", ") || selectedItem?.ingredients?.join(", "),
                },
                showInPopup?.includes("ingredients") && {
                  title: "Alergeni",
                  content:
                    products?.data?.[
                      selectedImageIndex
                    ]?.attributes?.ingredients?.data
                      ?.flatMap((item) => item?.attributes?.allergens?.data)
                      ?.map((item) => item?.attributes?.name)
                      .filter(Boolean)
                      ?.filter(
                        (allergen, index, self) =>
                          self.indexOf(allergen) === index
                      )
                      .join(", ") || selectedItem?.allergens?.join(", "),
                },
              ]?.filter(Boolean)}
            />
          </div>
        </div>
      </div>

      {/* Thumbnail Gallery Section with Scrolling */}
      {popupType === Enum_Componentcmsdataproductslist_Popuptype.Slider && (
        <div className="w-full flex items-center justify-center relative lg:w-2/3">
          {/* Left Arrow */}
          {canScrollLeft && (
            <button
              className="absolute -left-2 lg:-left-12 lg:block top-1/2 transform -translate-y-1/2 bg-gray-200 w-10 h-10 p-2 rounded-full shadow-md hover:bg-gray-300 z-10"
              onClick={slidePrevThumbnails}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}

          {/* Thumbnails Container */}
          <div
            ref={thumbnailsContainerRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide"
            onScroll={updateScrollButtons}
          >
            {products?.data?.map((item, index) => (
              <div
                key={index}
                ref={index === 0 ? firstThumbnailRef : null}
                className={`cursor-pointer p-2 ${
                  selectedImageIndex === index ? "border-2 border-blue-500" : ""
                }`}
                onClick={() => setSelectedImageIndex(index)}
              >
                <div className="w-24 h-24 overflow-hidden rounded-lg relative">
                  <Image
                    src={
                      item.attributes?.media?.data?.[0]?.attributes?.formats
                        ?.thumbnail?.url || ""
                    }
                    alt={
                      item.attributes?.media?.data?.[0]?.attributes
                        ?.alternativeText || "image"
                    }
                    fill
                    sizes="96px"
                    className="w-full h-full object-cover"
                    quality={80}
                  />
                </div>

                <p className="text-center mt-2 text-sm">
                  {item.attributes?.title}
                </p>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          {canScrollRight && (
            <button
              className="absolute -right-4 lg-right-14 block top-1/2 transform -translate-y-1/2 w-10 h-10 bg-gray-200 p-2 rounded-full shadow-md hover:bg-gray-300 z-10"
              onClick={slideNextThumbnails}
            >
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          )}
        </div>
      )}
    </div>
  </ModalContent>
);
